export const flightIndex: any = {
  sortBy: "Sort by",
  filterBy: "Filter by",
  baggageWithItinerary: "Itinerary{{index}}: {{baggageText}}",
  baggageAlertTitle: "Please check your checked baggage",
  baggageAlertDescription:
    "The difference between the price for a flight with checked baggage and the price for a flight without free checked baggage is shown, so if a flight does not have free checked baggage, the price will be higher if you add it.",
  detailModalTitle: "Flight details",
};
